import React, { useState } from 'react'  
import BookAnAppointment from '../components/BookAnAppointment';
const BookAnAppointmentPage = () => { 
    return ( 
        <BookAnAppointment/>
    )
}

export default BookAnAppointmentPage